/**
 * BPMN流程节点用户分配配置器
 * 支持多种分配类型：静态用户/角色/部门选择和动态分配
 */
import React, { useEffect, useMemo } from 'react';
import { Modal, Row, Col, Card, Button, message } from 'antd';
import AssignmentTypeList from './AssignmentTypeList';
import ConfigurationArea from './ConfigurationArea';
import PreviewArea from './PreviewArea';
import { useUserAssignmentStore } from './useUserAssignmentStore';
import { ASSIGNMENT_TYPES } from './constants';

const UserAssignmentSelector = ({ 
  visible, 
  onCancel, 
  value, // 受控模式的值
  onChange, // 受控模式的变更回调
  initialValue = null // 非受控模式的初始值
}) => {
  // 只获取当前组件需要的方法
  const initialize = useUserAssignmentStore(state => state.initialize)
  const reset = useUserAssignmentStore(state => state.reset)
  const getCurrentConfig = useUserAssignmentStore(state => state.getCurrentConfig)
  const validateConfig = useUserAssignmentStore(state => state.validateConfig)

  useEffect(() => {
    if (visible) {
      // 受控模式优先使用value，非受控模式使用initialValue
      const initValue = value !== undefined ? value : initialValue
      // 使用setTimeout确保在下一个事件循环中执行初始化
      setTimeout(() => {
        initialize(initValue)
      }, 0)
    } else {
      reset()
    }
  }, [visible, value, initialValue, initialize, reset]) // 监听value变化以支持受控模式

  const handleConfirm = () => {
    // 使用store的验证方法
    const validation = validateConfig();
    if (!validation.valid) {
      message.error(validation.message);
      return;
    }
    
    // 获取当前配置
    const result = getCurrentConfig();
    
    // 受控模式：调用onChange
    if (onChange) {
      onChange(result);
    }
    
    // 关闭对话框
    onCancel();
  };

  return (
    <Modal
      title="用户分配配置"
      open={visible}
      onCancel={onCancel}
      width={1000}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          取消
        </Button>,
        <Button key="confirm" type="primary" onClick={handleConfirm}>
          确定
        </Button>
      ]}
      destroyOnClose
    >
      <div className="flex h-[70vh] gap-4">
        {/* 左侧：分配类型选择 */}
        <div className="w-80 flex flex-col">
          <Card 
            title="分配类型" 
            size="small" 
            className="h-full flex flex-col"
            styles={{ body: { flex: 1, padding: '12px', overflow: 'hidden' } }}
          >
            <AssignmentTypeList />
          </Card>
        </div>
        
        {/* 右侧：配置和预览 */}
        <div className="flex-1 h-full overflow-hidden">
          <Row gutter={[0, 16]} className="h-full">
            {/* 配置区域 */}
            <Col span={24} className="h-1/2">
              <ConfigurationArea />
            </Col>
            
            {/* 预览区域 */}
            <Col span={24} className="h-1/2">
              <PreviewArea />
            </Col>
          </Row>
        </div>
      </div>
    </Modal>
  );
};

export default UserAssignmentSelector;